/**
 * Название системы в интерфейсе: в меню, на странице входа и в заголовке вкладки.
 * В левом меню Bitrix24 подпись берётся из названия локального приложения и меняется там же
 * (docs/runbook.md, «Сайт и вход из Bitrix24»).
 */
export const APP_NAME = 'Должностные инструкции';
/** Буква в значке рядом с названием. */
export const APP_MARK = 'Д';
